import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

export const useIntegration = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const rootIntegrationsPath = location.pathname.startsWith('/i/onboard') ? '/i/onboard' : '/s/integrations';

    return {
        t,
        rootIntegrationsPath,
    };
};
